import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,

} from "../../service/casino";
import { useLocation, useParams } from "react-router-dom";
import { getOddsByRunner, GetUniversalLastTenResult } from "./genericFunctions";
import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function MuflisTeenPatti() {
  const GAME_ID = "UNI_MUFLIS_TEEN_PATTI";
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const generic = GAME_ID == "UNI_1_CARD_20_20";
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };

  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
 
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt;
    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);

  return (
    <app-eu-teenpatti _nghost-ng-c1910803830="">
      <div
        style={{
          height: "100vh",
          overflowY: "scroll",
        }}
        _ngcontent-ng-c1910803830=""
      >
        <app-video-player _ngcontent-ng-c1910803830="" _nghost-ng-c595356512="">
          <div _ngcontent-ng-c595356512="" className="videoPlayer">
            <video
              _ngcontent-ng-c595356512=""
              id="remoteVideo"
              width="100%"
              height="100%"
              autoPlay=""
              playsInline=""
              muted=""
              style={{ backgroundColor: "black", backgroundSize: "contain" }}
            />

            <div _ngcontent-ng-c595356512="" className="video-overlay">
              <div _ngcontent-ng-c595356512="">
                <div
                  _ngcontent-ng-c595356512=""
                  className="round-id text-white"
                >
                  RID: {odds?.roundId}
                </div>
              </div>
            </div>

            {showWinnerOverlay && (
              <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                <div
                  _ngcontent-ng-c595356512=""
                  className="mini-result-new active"
                >
                  <span _ngcontent-ng-c595356512="">
                    {" "}
                    {odds?.roundWinner} win{" "}
                  </span>
                  {/**/}
                </div>
                <span
                  _ngcontent-ng-c595356512=""
                  style={{ position: "absolute" }}
                >
                  <canvas
                    _ngcontent-ng-c595356512=""
                    width="100vw"
                    height="100vh"
                  />
                </span>
                {/**/}
              </div>
            )}

            <div _ngcontent-ng-c595356512="" className="timer-overlay">
              <GenericCasinoTimer time={odds?.seconds} status={odds?.status} />
            </div>
          </div>

          <div
            _ngcontent-ng-c595356512=""
            id="rulesModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabelaexampleModalLabela"
            aria-hidden="true"
            className="modal fade"
          >
            <div
              _ngcontent-ng-c595356512=""
              className="modal-dialog rules-wrap"
            >
              <div
                _ngcontent-ng-c595356512=""
                role="document"
                id="rulesList___BV_modal_content_"
                tabIndex={-1}
                className="modal-content rules-content"
              >
                <header
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_header_"
                  className="rules-wrap"
                >
                  <a _ngcontent-ng-c595356512="">
                    <h3
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_title_"
                      data-bs-toggle="modal"
                      data-bs-target="#rulesModal"
                      className="modal-title"
                    >
                      Rules
                    </h3>
                  </a>
                  <button
                    _ngcontent-ng-c595356512=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    ×
                  </button>
                </header>
                <div
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_body_"
                  className="modal-body"
                >
                  <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                </div>
                <div _ngcontent-ng-c595356512="">
                  <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                    <li _ngcontent-ng-c595356512="">
                      <a
                        _ngcontent-ng-c595356512=""
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="btnok"
                      >
                        OK
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </app-video-player>
        <div _ngcontent-ng-c1910803830="" className="row p-2">
          {odds?.playerCards?.map((player, index) => (
            <div
              _ngcontent-ng-c1910803830=""
              className="col-6 d-flex justify-content-center"
            >
              <div _ngcontent-ng-c595356512="">
                {player?.cards
                  ?.sort((a, b) => {
                    if (index >= 1) {
                      return (
                        parseInt(b?.cardNumber?.split("_")[1]) -
                        parseInt(a?.cardNumber?.split("_")[1])
                      );
                    }
                    return a?.cardValue - b?.cardValue;
                  })
                  ?.map((card) => (
                    <img
                      _ngcontent-ng-c595356512=""
                      className="imgPadding"
                      src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                    />
                  ))}
              </div>
            </div>
          ))}
        </div>
        <div
          _ngcontent-ng-c1910803830=""
          className="d-flex justify-content-between align-items-center euTeenpattiboxes"
        >
          {odds?.markets?.map((item) =>
            item?.oddDetailsDTO?.map((odd, index) => (
              <div
               
                _ngcontent-ng-c1910803830=""
                className={`${
                  index == 0 ? "firstboxTp" : "Secondboxtp"
                } checkBetAPi text-center text-white ${
                  odds?.status == "SUSPEND" && " suspended eususpended"
                }`}
              >
                <div
                  _ngcontent-ng-c1910803830=""
                  className={`playerName ${
                    odds?.status == "SUSPEND" && "suspendedTxt"
                  }`}
                >
                  {odd?.runnerName}{" "}
                </div>
                <div
                  _ngcontent-ng-c1910803830=""
                  className={`priceSection ${
                    odds?.status == "SUSPEND" && "suspendedTxt"
                  }`}
                >
                  {odd?.back1}
                </div>
              </div>
            ))
          )}
        </div>

        <section
          _ngcontent-ng-c1910803830=""
          id="functionZone"
          className="function_zone"
        >
          <ul _ngcontent-ng-c1910803830="" id="chips" className="chips">
            {[
              { img: "chips1", amount: 100, label: "100" },
              { img: "chips1", amount: 500, label: "500" },
              { img: "chips1k", amount: 1000, label: "1k" },
              { img: "chips5", amount: 5000, label: "5k" },
              { img: "chips10", amount: 10000, label: "10k" },
              { img: "chips20", amount: 25000, label: "25k" },
              { img: "chips1k", amount: 50000, label: "50k" },
              { img: "chips1k", amount: 100000, label: "1L" },
            ].map((item) => (
              <li
                onClick={() => {
                  setPlaceBetPayload({
                    ...placeBetPayload,
                    amount: item.amount,
                  });
                }}
                _ngcontent-ng-c1910803830=""
                className={`chips_1 ${
                  placeBetPayload?.amount === item.amount ? "now" : ""
                }`}
              >
                <img
                  _ngcontent-ng-c1910803830=""
                  src={`https://casino.queenexch.com/assets/chips/${item?.img}.svg`}
                />

                <p _ngcontent-ng-c1910803830="">{item.label} </p>
                <span _ngcontent-ng-c1910803830="" className="ring">
                  ring
                </span>
              </li>
            ))}
          </ul>
        </section>
        <GetUniversalLastTenResult lastResult={lastResult} />
      </div>
    </app-eu-teenpatti>
  );
}
